import * as React from 'react';
import styles from "./Status.module.css"

export type StatusProps = {
  message: string;
};

export const Status = ({ message }: StatusProps) => {
  return (
    <div>
    <dialog className={styles.gradientBorder} open={true}>
      <p className={styles.statusMessage}>{message}</p>
    </dialog>
    <div className={styles.dialogBackdrop} />
    </div>
  );
}
